import { get } from 'src/axios/post'
import { reset, wait } from 'src/store'

const loggedInStates = () => {
  return [
    'licences',
    'needsReloading',
    'loading'
  ]
}

const defaultStates = () => {
  return {
    licences: [],
    needsReloading: true,
    loading: false
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setLoading (state, val) {
      state.loading = Boolean(val)
    },
    setNeedsReloading (state, val) {
      state.needsReloading = Boolean(val)
    },
    setLicences (state, licences) {
      state.licences = licences
      state.needsReloading = false
    }
  },
  actions: {
    async getLicences ({ commit, state }) {
      if (state.loading || !state.needsReloading) {
        if (state.loading) {
          await wait(state, 'loading')
        }
        return
      }
      commit('setLoading', true)
      const { status, payload } = await get('v1/business/company/licences/all')
      commit('setLoading', false)
      if (status === 'success') {
        commit('setLicences', payload.licences)
      }
    }
  },
  getters: {
    getLicences: state => state.licences,
    isLoading: state => state.loading
  }
}
